import { render, staticRenderFns } from "./PasswordController.vue?vue&type=template&id=a4bf4ebe"
import script from "./PasswordController.vue?vue&type=script&lang=js"
export * from "./PasswordController.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports